// libraries
import { useCallback, ReactElement, useEffect, useMemo } from 'react'

// constants
import { HOME_PAGE_URL } from 'constants/common'

// components
import { Cover } from 'components/common'
import { handleErrorSideEffects } from './utils'

type AppErrorProps = {
  title?: string
  message?: string
  refreshButtonContent?: string
  redirectUrl?: string
}

const AppError = ({
  title = 'Something went wrong',
  message = '',
  refreshButtonContent = 'Refresh',
  redirectUrl = HOME_PAGE_URL,
}: AppErrorProps): ReactElement => {
  const refreshPage = useCallback(() => {
    window.location.href = redirectUrl
  }, [redirectUrl])

  useEffect(() => {
    if (message) {
      handleErrorSideEffects({ message, refreshPage })
    }
  }, [message, refreshPage])

  const messageContent = useMemo(
    () => (
      <>
        <h2 className='fw-lighter'>{title}</h2>
        <h4>{message}</h4>
      </>
    ),
    [title, message]
  )

  return (
    <Cover
      onClick={refreshPage}
      buttonContent={refreshButtonContent}
      message={messageContent}
    />
  )
}

export default AppError
